import styled from 'styled-components';

export const Bar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 12px;
  padding: 6px 12px;
  font-size: 13px;
`;

export const Name = styled.span`
  font-weight: 650;
`;




/** Green: someone's turn, or someone here. */
export const LIVE_GREEN = '#3ddc84';

/** Whose turn it is: a green dot by their name. */
export const TurnDot = styled.i`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${LIVE_GREEN};
  box-shadow: 0 0 0 3px ${LIVE_GREEN}40;
`;

/** The opponent's online dot: green while they have the game open. */
export const Presence = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-left: 6px;
  vertical-align: middle;
  border-radius: 50%;
  background: ${({ $online }) => ($online ? LIVE_GREEN : 'transparent')};
  box-shadow: inset 0 0 0 1.5px ${({ $online }) => ($online ? LIVE_GREEN : 'var(--muted)')};
`;
